import { routePaths } from '../../routePaths';
import { translate } from '../../utils';
import { RouteType } from '../../types';
import { BackofficePermission } from '../../generated/graphql';
import { DashboardIcon } from '../../ui-kit';
import { Dashboard } from '../../modules';

const DashboardRoute: RouteType = {
    exact: true,
    path: routePaths.dashboard,
    title: translate('Dashboard'),
    icon: DashboardIcon,
    component: Dashboard,
    permissions: {
        backoffice: [BackofficePermission.HasAccess],
    },
};

export default DashboardRoute;
